// extracted by mini-css-extract-plugin
export var text = "ServiceWorkerRefresh-module--text--242c8";
export var wrapper = "ServiceWorkerRefresh-module--wrapper--4d177";